import { render } from "./LayoutCommonPage.vue?vue&type=template&id=b2b21f6a"
import script from "./LayoutCommonPage.vue?vue&type=script&lang=js"
export * from "./LayoutCommonPage.vue?vue&type=script&lang=js"

import "./LayoutCommonPage.vue?vue&type=style&index=0&id=b2b21f6a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__